<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { ADMIN_STATS } from '@/store/types';
import statsApi from '../../../apis/admin/tickets.api';

export default {
  setup() {
    const store = useStore();
    const query = ref(null);
    query.value = statsApi.usefetchHomeStatsAdminQuery(0);
    if (query.value) {
      store.commit(ADMIN_STATS.SET_HOME_STATS_QUERY, query);
    }
    return { query };
  },
};
</script>
